<ion-modal
  [isOpen]="isModalOpen$ | async"
  (ionModalDidDismiss)="closeModal()"
  [class]="
    (platformService?.isTouchExperience$ | async)
      ? 'ion-modal-touch'
      : 'modal-desktop-size-xl'
  "
  [initialBreakpoint]="
    platformService?.platformType !== platformService?.platformEnum.desktop
      ? 1
      : undefined
  "
  [breakpoints]="
    platformService?.platformType !== platformService?.platformEnum.desktop
      ? [0, 1]
      : undefined
  "
  id="AddNonUsfProductModal"
>
  <ng-template>
    <app-modal-with-nav-inline
      [rootPage]="dualPaneRef"
      [rootPageParams]="dualPaneModalData"
    >
    </app-modal-with-nav-inline>
  </ng-template>
</ion-modal>
